// Lights
const white = '#FFFFFF';
const catskillWhite = '#E5EAF4';
const silverChalice = '#AAAAAA';
const azureRadiance = '#0096FF';

// Darks
const black = '#000000';
const text = '#657496';
const navyBlue = '#00106B';
const cadetBlue = '#afb7c9';
const smalt = '#00398E';
const springGreen = '#00FA94';

// Colors
const error = '#FF6C6C';
const success = '#66BE54';
const cornflowerBlue = '#5684EB';

export const LIGHT_COLORS = {
    // General
    white,
    black,
    text,
    success,
    error,
    background: catskillWhite,
    divider: silverChalice,
    inactiveItem: success,
    activeItem: cornflowerBlue,

    // sidebar
    sidebarBg: smalt,
    sidebarBorderRight: navyBlue,
    sidebarItem: azureRadiance,
    sidebarItemActive: springGreen,
    sidebarItemActiveBg: navyBlue,

    // input
    inputBorder: cadetBlue,
    inputBorderActive: navyBlue,

}